<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Update Physical Sample'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-iftalabel>
            <p-inputmask
                    id="physical-sample-mac-address"
                    mask="**:**:**:**:**:**"
                    [(ngModel)]="physicalSample.macAddress"
                    placeholder="__:__:__:__:__:__"
                    class="w-full"
            ></p-inputmask>
            <label for="physical-sample-mac-address">MAC Address <span class="text-red-500">*</span></label>
        </p-iftalabel>

        <p-ifta-label>
            <p-select
                    [disabled]="true"
                    id="physical-sample-state"
                    [(ngModel)]="this.physicalSample.state"
                    [options]="availableStates"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select State"
                    class="w-full"
                    appendTo="body"
            ></p-select>
            <label for="physical-sample-state">State</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [disabled]="true"
                    id="physical-sample-sample"
                    [(ngModel)]="this.physicalSample.sampleId"
                    [options]="availableSamples"
                    optionLabel="printedName"
                    optionValue="id"
                    placeholder="Select Sample"
                    class="w-full"
                    [panelStyle]="{ 'width': '100%' }"
                    appendTo="body"
            >
                <ng-template #selectedItem let-sample>
                    @if (sample) {
                        <div class="flex items-center gap-2">
                            @if (sample.media?.content?.cloudfrontUrl) {
                                <img
                                        [src]="sample.media.content.cloudfrontUrl"
                                        alt="{{ sample.printedName }}"
                                        class="w-6 h-6 object-cover rounded"
                                />
                            }
                            <div class="flex flex-col">
                                <span class="font-medium">{{ sample.printedName }}</span>
                                <small class="text-gray-500">{{ sample.detailNames }}</small>
                                <div class="flex items-center gap-2 mt-1">
                                    <!-- ES2 key -->
                                    <span class="text-xs text-gray-600">{{ sample.es2Key }}</span>
                                    <!-- type tag -->
                                    <p-tag
                                            [value]="sample.type?.name"
                                            class="text-xs"
                                            severity="secondary"
                                    ></p-tag>
                                    <!-- category tag -->
                                    <p-tag
                                            [value]="sample.category?.name ?? 'No category'"
                                            class="text-xs"
                                            severity="secondary"
                                    ></p-tag>
                                </div>
                            </div>
                        </div>
                    }
                </ng-template>

                <ng-template let-sample #item>
                    <div class="flex items-center gap-2">
                        @if (sample.media?.content?.cloudfrontUrl) {
                            <img
                                    [src]="sample.media.content.cloudfrontUrl"
                                    alt="{{ sample.printedName }}"
                                    class="w-6 h-6 object-cover rounded"
                            />
                        }
                        <div class="flex flex-col">
                            <span>{{ sample.printedName }}</span>
                            <small class="text-gray-500">{{ sample.detailNames }}</small>

                            <div class="flex items-center gap-2 mt-1">
                                <span class="text-xs text-gray-600">{{ sample.es2Key }}</span>
                                <p-tag
                                        [value]="sample.type?.name"
                                        severity="secondary"
                                        class="text-xs"
                                ></p-tag>
                                <p-tag
                                        [value]="sample.category?.name ?? 'No category'"
                                        severity="secondary"
                                        class="text-xs"
                                ></p-tag>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-select>
            <label for="physical-sample-sample">Sample <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    id="physical-sample-dealership"
                    [(ngModel)]="this.physicalSample.ownerDealershipId"
                    [options]="availableDealerships"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Owner Dealership"
                    class="w-full"
                    appendTo="body"
            ></p-select>
            <label for="physical-sample-dealership">Owner Dealership</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    id="physical-sample-studio"
                    [(ngModel)]="this.physicalSample.studioId"
                    [options]="availableStudios"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Studio"
                    class="w-full"
                    appendTo="body"
            ></p-select>
            <label for="physical-sample-studio">Studio</label>
        </p-ifta-label>

        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Update"
                icon="pi pi-check"
                (click)="updatePhysicalSample()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
